module.exports = __webpack_public_path__ + "static/media/lora.b2c3ec49.jpg";